export default "__VITE_ASSET__YW7UJwJC__";